import React from 'react';
import PropTypes from 'prop-types';

export const SortArrowUp = ({ width, height, ...props }) => (
  <svg
    data-icon='sort-arrow-up'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m5 15 7-7 7 7H5Z'
    />
  </svg>
);

SortArrowUp.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

SortArrowUp.defaultProps = {
  width: 24,
  height: 24,
};
